import React, { useState, createContext, useEffect } from "react";
import { startJourney } from "../../services";
import { CRIARE } from "../../constants/appNames";
import { DefaultTheme, ThemeProvider } from "styled-components";
import HistoryPages from "../../events";

import {
  Question16,
  Question01,
  Question02,
  Question03,
  Question04,
  Question05,
  Question06,
  Question07,
  Question08,
  Question09,
  Question10,
  Question11,
  Question12,
  Question13,
  Question14,
  Question15,
  Question17,
  Question18,
  Question19,
  Question20,
  Question21,
  Question22,
  Question23,
} from "./pages";
import eventTypes from "../../events/event-types.const";

const pagesFlow = [
  <Question16 />,
  <Question01 />,
  <Question02 />,
  <Question03 />,
  <Question04 />,
  <Question05 />,
  <Question06 />,
  <Question07 />,
  <Question08 />,
  <Question09 />,
  <Question10 />,
  <Question11 />,
  <Question12 />,
  <Question13 />,
  <Question14 />,
  <Question15 />,
  <Question17 />,
  <Question18 />,
  <Question19 />,
  <Question20 />,
  <Question21 />,
  <Question22 />,
  <Question23 />,
];

interface INavigateButtons {
  next: (pageNumber: number) => void;
}

const NavigateButtonsContext = createContext<INavigateButtons>(
  {} as INavigateButtons
);

interface IDataUser {
  userName: string;
  userWhats: string;
  setUserName: React.Dispatch<React.SetStateAction<string>>;
  setUserWhats: React.Dispatch<React.SetStateAction<string>>;
  token: string;
  setToken: React.Dispatch<React.SetStateAction<string>>;
  updateTheme: React.Dispatch<React.SetStateAction<DefaultTheme>>;
  homeIgnored: boolean;
  setHomeIgnored: React.Dispatch<React.SetStateAction<boolean>>;
  getLastPage: () => number;
  appendToHistory: (pageNumber: number) => void;
}

const DataUserContext = createContext<IDataUser>({} as IDataUser);

function App() {
  const [pagesFlowIndex, setPagesFlowIndex] = useState<number>(0);
  const [userName, setUserName] = useState<string>("");
  const [userWhats, setUserWhats] = useState<string>("");
  const [token, setToken] = useState<string>("");
  const [isApiDown, setIsApiDown] = useState<boolean>(false);
  const [criareTheme, setCriareTheme] = useState({} as DefaultTheme);
  const [homeIgnored, setHomeIgnored] = useState<boolean>(false);
  const [historyPages, setHistoryPages] = useState<number[]>([] as number[]);

  function getLastPage() {
    const lastPage = historyPages[historyPages.length - 1];
    setHistoryPages((prevState) => prevState.slice(0, prevState.length - 1));
    return lastPage;
  }

  function appendToHistory(pageNumber: number) {
    setHistoryPages((prevState) => [...prevState, pageNumber]);
  }

  /**
   *
   * @param pageNumber is the sufix number in Question's page name
   */
  function next(pageNumber: number) {
    appendToHistory(pageNumber);
    goToPage(pageNumber);
  }

  function goToPage(pageNumber: number) {
    const indexPage = pageNumber - 1 <= 0 ? 0 : pageNumber - 1;
    setPagesFlowIndex(indexPage);
  }

  useEffect(() => {
    HistoryPages.emit(eventTypes.RESET);
    startJourney(CRIARE)
      .then(({ token, ...theme }) => {
        setToken(token);
        setCriareTheme(theme);
      })
      .catch(() => setIsApiDown(true));
  }, []);

  // useEffect(() => {
  //   if (criareTheme.steps) {
  //     const question01Images = [
  //       criareTheme.steps.etapa_inicial.propriedades.imagens
  //         .etapa_inicial_imagemBanner.url,
  //       criareTheme.steps.etapa_inicial.propriedades.imagens
  //         .etapa_inicial_iconeNao.url,
  //       criareTheme.steps.etapa_inicial.propriedades.imagens
  //         .etapa_inicial_iconeSim.url,
  //     ];

  //     const question02Images = [
  //       criareTheme.steps.etapa_escolha_de_estilo.propriedades.imagens
  //         .etapa_escolha_de_estilo_imagemBanner.url,
  //       ...Object.values(
  //         criareTheme.steps.etapa_escolha_de_estilo.propriedades.conteudo
  //           .galeria
  //       ).map(({ url }) => url),
  //     ];

  //     const question03Images = [
  //       criareTheme.steps.etapa_dados_pessoais.propriedades.imagens
  //         .etapa_dados_pessoais_imagemBanner.url,
  //     ];

  //     const question04Images = [
  //       criareTheme.steps.etapa_email.propriedades.imagens
  //         .etapa_email_imagemBanner.url,
  //     ];

  //     const question05Images = [
  //       criareTheme.steps.etapa_apresentacao_de_estilo.propriedades.imagens
  //         .etapa_apresentacao_de_estilo_imagemBanner.url,
  //     ];

  //     criareTheme.steps.etapa_apresentacao_de_estilo.propriedades.conteudo.estilo?.imagens_galeria.forEach(
  //       (url) => question05Images.push(url)
  //     );

  //     const question06Images = [
  //       criareTheme.steps.etapa_possui_arquiteto.propriedades.imagens
  //         .etapa_possui_arquiteto_imagemBanner.url,
  //       criareTheme.steps.etapa_possui_arquiteto.propriedades.imagens
  //         .etapa_possui_arquiteto_iconeNao.url,
  //       criareTheme.steps.etapa_possui_arquiteto.propriedades.imagens
  //         .etapa_possui_arquiteto_iconeSim.url,
  //     ];

  //     const question07Images = [
  //       criareTheme.steps.etapa_dados_arquiteto.propriedades.imagens
  //         .etapa_dados_arquiteto_imagemBanner.url,
  //     ];

  //     const question08Images = [
  //       criareTheme.steps.etapa_expectativa_de_tempo.propriedades.imagens
  //         .etapa_expectativa_de_tempo_imagemBanner.url,
  //       criareTheme.steps.etapa_expectativa_de_tempo.propriedades.conteudo
  //         .inputs[0].icone[1],
  //       criareTheme.steps.etapa_expectativa_de_tempo.propriedades.conteudo
  //         .inputs[1].icone[1],
  //       criareTheme.steps.etapa_expectativa_de_tempo.propriedades.conteudo
  //         .inputs[2].icone[1],
  //       criareTheme.steps.etapa_expectativa_de_tempo.propriedades.conteudo
  //         .inputs[3].icone[1],
  //     ];

  //     const question09Images = [
  //       criareTheme.steps.etapa_comodos.propriedades.imagens
  //         .etapa_comodos_imagemBanner.url,
  //       criareTheme.steps.etapa_comodos.propriedades.conteudo.inputs[0]
  //         .icone[1],
  //       criareTheme.steps.etapa_comodos.propriedades.conteudo.inputs[1]
  //         .icone[1],
  //       criareTheme.steps.etapa_comodos.propriedades.conteudo.inputs[2]
  //         .icone[1],
  //       criareTheme.steps.etapa_comodos.propriedades.conteudo.inputs[3]
  //         .icone[1],
  //       criareTheme.steps.etapa_comodos.propriedades.conteudo.inputs[4]
  //         .icone[1],
  //       criareTheme.steps.etapa_comodos.propriedades.conteudo.inputs[5]
  //         .icone[1],
  //       criareTheme.steps.etapa_comodos.propriedades.conteudo.inputs[6]
  //         .icone[1],
  //       criareTheme.steps.etapa_comodos.propriedades.conteudo.inputs[7]
  //         .icone[1],
  //     ];

  //     const question10Images = [
  //       criareTheme.steps.etapa_primeira_compra.propriedades.imagens
  //         .etapa_primeira_compra_imagemBanner.url,
  //       criareTheme.steps.etapa_primeira_compra.propriedades.imagens
  //         .etapa_primeira_compra_iconeNao.url,
  //       criareTheme.steps.etapa_primeira_compra.propriedades.imagens
  //         .etapa_primeira_compra_iconeSim.url,
  //     ];

  //     const question11Images = [
  //       criareTheme.steps.etapa_timeline_informativa.propriedades.imagens
  //         .etapa_timeline_informativa_imagemBanner.url,
  //     ];

  //     const question12Images = [
  //       criareTheme.steps.etapa_final.propriedades.imagens
  //         .etapa_final_imagemBanner.url,
  //     ];

  //     const IMAGES: string[] = [
  //       ...question01Images,
  //       ...question03Images,
  //       ...question02Images,
  //       ...question04Images,
  //       ...question05Images,
  //       ...question06Images,
  //       ...question07Images,
  //       ...question08Images,
  //       ...question09Images,
  //       ...question10Images,
  //       ...question11Images,
  //       ...question12Images,
  //     ];

  //     const loadImage = (imageUrl: string) => {
  //       return new Promise((resolve) => {
  //         const loadImg = new Image();
  //         loadImg.src = imageUrl;
  //         loadImg.onload = () => resolve(<img src={imageUrl} alt="" />);
  //       });
  //     };

  //     const fetchedImages = IMAGES.map((imageUrl) => loadImage(imageUrl));

  //     Promise.all(fetchedImages).then(() => setImgsLoaded(true));
  //   }
  // }, [criareTheme]);

  const ContextProviders: React.FC = React.memo(({ children }) => (
    <ThemeProvider theme={criareTheme}>
      <NavigateButtonsContext.Provider value={{ next }}>
        <DataUserContext.Provider
          value={{
            userName,
            userWhats,
            setUserName,
            setUserWhats,
            token,
            setToken,
            updateTheme: setCriareTheme,
            homeIgnored,
            setHomeIgnored,
            getLastPage,
            appendToHistory,
          }}
        >
          {children}
        </DataUserContext.Provider>
      </NavigateButtonsContext.Provider>
    </ThemeProvider>
  ));

  const ServerIsDownPage: React.FC = () => <h1>Servidor offline</h1>;

  return (
    <ContextProviders>
      {isApiDown ? <ServerIsDownPage /> : pagesFlow[pagesFlowIndex]}
    </ContextProviders>
  );
}

export default App;
export { NavigateButtonsContext, DataUserContext };
